module.exports={Remove:"Ta bort"};